module.exports = __webpack_public_path__ + "static/media/motivacion.a526ac1c.svg";